var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.direccionId)?_c('direccion-collapse',{attrs:{"title":"Dirección seleccionada"},model:{value:(_vm.direccionId),callback:function ($$v) {_vm.direccionId=$$v},expression:"direccionId"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }